import { flaggedEmailsFolderName } from './sortFoldersForDisplay.locstring.json';
import { defaultTasksFolderName } from '../strings.locstring.json';
import loc from 'owa-localize';
import TodoFolder from '../store/schema/TodoFolder';
import { compare } from 'owa-datetime';

export default function sortFoldersForDisplay(folders: TodoFolder[]): TodoFolder[] {
    // Add My Day view is tracked by VSO: 30588
    const nonSpecialFolders: TodoFolder[] = [];
    let defaultFolder: TodoFolder = null;
    let commitmentsFolder: TodoFolder = null;
    let flaggedEmailsFolder: TodoFolder = null;

    folders.forEach(folder => {
        if (folder.IsDefaultFolder) {
            defaultFolder = folder;
            defaultFolder.Name = loc(defaultTasksFolderName);
        } else if (folder.FolderType === 'Commitments') {
            commitmentsFolder = folder;
        } else if (folder.FolderType === 'FlaggedEmails') {
            flaggedEmailsFolder = folder;
            flaggedEmailsFolder.Name = loc(flaggedEmailsFolderName);
        } else {
            nonSpecialFolders.push(folder);
        }
    });

    // First sort the regular folders in descending order of OrderDateTime
    const sortedFolders = nonSpecialFolders.sort((lhs: TodoFolder, rhs: TodoFolder) => {
        if (lhs.OrderDateTime && rhs.OrderDateTime) {
            return compare(rhs.OrderDateTime, lhs.OrderDateTime);
        }

        if (lhs.OrderDateTime) {
            return -1;
        }

        if (rhs.OrderDateTime) {
            return 1;
        }

        // both folders don't have OrderDateTime
        return 0;
    });

    // Now add our special folders.
    if (commitmentsFolder) {
        sortedFolders.splice(0, 0, ...[commitmentsFolder]);
    }

    if (flaggedEmailsFolder) {
        sortedFolders.splice(0, 0, ...[flaggedEmailsFolder]);
    }

    if (defaultFolder) {
        sortedFolders.splice(0, 0, ...[defaultFolder]);
    }

    return sortedFolders;
}
